<template>
  <div id="tour">
    <tour-overview-card @open-dialog="open = true"></tour-overview-card>
    <div class="tour__details">
      <tour-detail
        icon="briefcase"
        :color="active.primaryColor"
        title="Anreisen & Ankommen"
        :text="active.arrivalInfo"
      ></tour-detail>
      <tour-detail
        icon="star"
        :color="active.primaryColor"
        title="Ihr Auszeit Erlebnis"
        :text="active.experienceInfo"
      ></tour-detail>
      <tour-detail
        icon="send"
        :color="active.primaryColor"
        title="Ausklang & Abreise"
        :text="active.departureInfo"
      ></tour-detail>
    </div>
    <div class="tour__end">
      <div
        class="tour__button"
        :style="{backgroundColor: active.primaryColor}"
        @click="open = true"
      >Jetzt buchen</div>
      <div class="tour__info">
        <span>Noch Fragen? Rufen Sie an!</span>
        <span>0176 834 915 08</span>
      </div>
    </div>
    <div class="tour__map-container">
      <div class="tour__map" id="map"></div>
    </div>
    <booking-dialog :dialog="open" @close="open = false" @click="open = false"></booking-dialog>
    <!--<MglMap
      class="tour__map"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :center="active.coordinates"
      :zoom="mapZoom"
    >
      <MglMarker :coordinates="active.coordinates">
        <div slot="marker" class="tour__map-marker"></div>
      </MglMarker>
    </MglMap>-->
  </div>
</template>

<script>
import TourOverviewCard from "./components/overview-card/TourOverviewCard";
import TourDetail from "./components/detail/TourDetail";
import BookingDialog from "./components/booking/BookingDialog";
//import Mapbox from "mapbox-gl";
//import { MglMap, MglMarker } from "vue-mapbox";
import mapboxgl from "mapbox-gl";

export default {
  name: "Tour",
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiZmthbnpsZXIiLCJhIjoiY2sybm9uZGF3MHM2NTNocGU1cDc2bmtzbCJ9.SOyxm3oiDAvJT2-hc5C5Pg",
      mapStyle: "mapbox://styles/mapbox/outdoors-v11",
      mapZoom: 10,
      map: null,
      marker: null,
      open: false
    };
  },

  /* created() {
    this.mapbox = Mapbox;
  },*/
  computed: {
    active() {
      return this.getTourList().find(
        tour => `/${tour.id}` === this.$route.path
      );
    }
  },

  watch: {
    active(newValue) {
      this.map.flyTo({ center: newValue.coordinates });
      this.marker.setLngLat(newValue.coordinates);
    }
  },
  mounted() {
    this.$nextTick(() => {
      mapboxgl.accessToken = this.accessToken;
      this.map = new mapboxgl.Map({
        container: "map",
        style: this.mapStyle,
        minzoom: 1.3,
        center: this.active ? this.active.coordinates : [-74.0073, 40.7124], // Manhattan
        zoom: 10
      });

      const el = document.createElement("div");
      el.className = "tour__map-marker";
      el.style.backgroundImage = `url(${require("../assets/badge.svg")})`;
      el.style.width = "28px";
      el.style.height = "59px";

      this.marker = new mapboxgl.Marker(el)
        .setLngLat(this.active ? this.active.coordinates : [-74.0073, 40.7124])
        .addTo(this.map);
    });
  },
  components: {
    TourOverviewCard,
    TourDetail,
    BookingDialog
    //MglMap,
    //MglMarker
  }
};
</script>

<style scoped lang="scss">
#tour {
  display: block;
  position: relative;
  background-image: linear-gradient(
    to bottom,
    #f0f0f0 61%,
    rgba(247, 247, 247, 0)
  );
  background-size: 100% 512px;
  padding-top: 56px;
}

.tour__details {
  max-width: 960px;
  margin: auto;

  > div {
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 40px;
    }
  }
}

.tour__end {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto 80px;
  max-width: 960px;
}

.tour__button {
  border-radius: 4px;
  line-height: 20px;
  padding: 8px 24px;
  //font-family: Soleil;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.7px;
  color: #ffffff;
  text-transform: uppercase;
  margin-left: 72px;
  margin-right: 24px;
  cursor: pointer;
  flex: 0 0 auto;
}

.tour__info {
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #999999;

  > span {
    margin-right: 8px;

    &:last-child {
      //font-family: Soleil;
      font-family: Lato;
      font-weight: normal;
    }
  }
}

.tour__map-container {
  margin: 0 48px;
}

.tour__map {
  width: 100%;
  max-width: 1024px;
  height: 240px;
  margin: 80px auto;
  border-radius: 4px;
}

.tour__map-marker {
  display: block;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
}

@media (max-width: 1023px) {
  #tour {
    padding-top: 0;
  }

  .tour__details {
    margin: 0 48px;
    //padding-top: 56px;

    > div {
      margin-bottom: 56px;

      &:last-child {
        margin-bottom: 56px;
      }
    }
  }

  .tour__end {
    flex-direction: column;
    align-items: flex-start;
  }

  .tour__button {
    margin-left: 48px;
    margin-bottom: 16px;
  }

  .tour__info {
    margin-left: 48px;
  }

  .tour__map-container {
    margin: 0 48px;
  }
}

@media (max-width: 767px) {
  .tour__details {
    margin: 0 24px;
  }

  .tour__button {
    margin-left: 24px;
  }

  .tour__info {
    margin-left: 24px;

    > span {
      display: block;
      text-align: left;
    }
  }

  .tour__map-container {
    margin: 0 24px;
  }
}
</style>
